export const Gender = {
  male: 'male',
  female: 'female',
} as const;

export type Gender = (typeof Gender)[keyof typeof Gender];